import _ from "lodash";
import client from "lib/apolloClient/client";
import { cache } from "lib/apolloClient";
import { getProjectIBDefinedTasksQuery } from "../modules/ReportV2Queries";
import { projectTaskSubmissionItemResponseFragment } from "Projects/routes/DeadlinesV2/modules/DeadlinesV2Fragments";
import {
  updateProjectDeadlineMutation,
  updateProjectDeadlineSubmissionMutation,
  updateSubmissionItemResponseMutation,
  updateAttachmentMutation,
  deleteAttachmentMutation,
} from "../modules/ReportV2Mutations";
import asyncWrap from "Utils/asyncWrap";
import {
  createAttachmentMutationForProjects,
  createProjectTemplateCopyMutation,
} from "Projects/modules/ProjectMutations";

import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

export const updateProjectDeadline = ({
  input,
  extraParams: {
    vars: { getProjectIBDefinedTasksFilters },
  },
}) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: updateProjectDeadlineMutation,
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getProjectIBDefinedTasksQuery,
            variables: getProjectIBDefinedTasksFilters,
          },
        ],
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateProjectDeadlineSubmission = ({
  input,
  extraParams: {
    vars: { getProjectIBDefinedTasksFilters },
  },
}) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: updateProjectDeadlineSubmissionMutation,
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getProjectIBDefinedTasksQuery,
            variables: getProjectIBDefinedTasksFilters,
          },
        ],
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const createAttachment = ({
  input,
  extraParams: {
    vars: { getProjectIBDefinedTasksFilters },
  },
}) => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: createAttachmentMutationForProjects,
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getProjectIBDefinedTasksQuery,
            variables: getProjectIBDefinedTasksFilters,
          },
        ],
      });

      return _.get(response, "data.platform.createAttachment");
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const deleteAttachment = ({
  input,
  extraParams: {
    vars: { getProjectIBDefinedTasksFilters },
  },
}) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: deleteAttachmentMutation,
        variables: { ...input },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getProjectIBDefinedTasksQuery,
            variables: getProjectIBDefinedTasksFilters,
          },
        ],
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateAttachment = ({
  input,
  extraParams: {
    vars: { getProjectIBDefinedTasksFilters },
  },
}) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: updateAttachmentMutation,
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getProjectIBDefinedTasksQuery,
            variables: getProjectIBDefinedTasksFilters,
          },
        ],
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateSubmissionItemResponse = ({ input }) => {
  cache.updateFragment(
    {
      id: `ProjectTaskSubmissionItemResponse:${input?.id}`,
      fragment: projectTaskSubmissionItemResponseFragment,
      fragmentName: "projectTaskSubmissionItemResponseItem",
    },
    data => {
      return {
        ...data,
        value: input?.value,
      };
    }
  );

  return async dispatch => {
    try {
      await client.mutate({
        mutation: updateSubmissionItemResponseMutation,
        variables: { input },
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const createProjectTemplateCopy = async ({
  projectGroupReportTemplateId,
  projectGroupId,
  submissionItemResponseId,
  getProjectIBDefinedTasksFilters,
}) => {
  const [error, result] = await asyncWrap(
    client.mutate({
      mutation: createProjectTemplateCopyMutation,
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: getProjectIBDefinedTasksQuery,
          variables: getProjectIBDefinedTasksFilters,
        },
      ],
      variables: {
        input: {
          submissionItemResponseId,
          projectGroupReportTemplateId,
          projectGroupId,
        },
      },
    })
  );
  return {
    error,
    result,
  };
};
